import { Route } from '@angular/router';
import { pagePermissionActivate } from '../page-permission';

/** Crop master data under `/crops/...` (default: `crops/crop`). */
export const cropsRoutes: Route = {
    path: 'crops',
    data: { title: 'crops' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'crop' },
        {
            path: 'crop',
            loadComponent: () => import('./crop/crop.component').then((m) => m.CropComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'crop' },
        },
        {
            path: 'crop-class',
            loadComponent: () => import('./crop-class/crop-class.component').then((m) => m.CropClassComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'crop-class' },
        },
        {
            path: 'crop-type',
            loadComponent: () => import('./crop-type/crop-type.component').then((m) => m.CropTypeComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'crop-type' },
        },
        {
            path: 'crop-class-crop-type',
            loadComponent: () =>
                import('./crop-class-crop-type/crop-class-crop-type.component').then((m) => m.CropClassCropTypeComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'crop-class-crop-type' },
        },
        {
            path: 'crop-produce',
            loadComponent: () => import('./crop-produce/crop-produce.component').then((m) => m.CropProduceComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'crop-produce' },
        },
        {
            path: 'crop-variety',
            loadComponent: () => import('./crop-variety/crop-variety.component').then((m) => m.CropVarietyComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'crop-variety' },
        },
        {
            path: 'harvestable-stage',
            loadComponent: () =>
                import('./harvestable-stage/harvestable-stage.component').then((m) => m.HarvestableStageComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Harvestable stage' },
        },
        {
            path: 'phenological-stage',
            loadComponent: () =>
                import('./phenological-stage/phenological-stage.component').then((m) => m.PhenologicalStageComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Phenological stage' },
        },
        {
            path: 'gdd-crop-threshold',
            loadComponent: () =>
                import('./gdd-crop-threshold/gdd-crop-threshold.component').then((m) => m.GddCropThresholdComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'gdd-crop-threshold' },
        },
    ],
};
